import { getLetterScore, getScoreLegends } from "../../../utils/utils";
import TitleStripe from "../../common/TitleStripe";

const BLOCK_KEYS = new Set([
  "defineRisco",
  "acertaEssencial",
  "defineRiscoPositivo",
  "acertaEssencialPositivo",
  "acertaCompleto",
  "defineLimite",
  "defineLimitePositivo",
  "defineNegocioPositivo",
  "spcMixTopPF",
  "spcMixTopPJ",
]);

/**
 * Varre profundamente objetos/arrays procurando por chaves bloqueadas.
 * - Ignora valores primitivos.
 * - Evita loops em estruturas com referências cíclicas via WeakSet.
 */
function hasBlockedKeyDeep(input, visited = new WeakSet()) {
  if (input == null || typeof input !== "object") return false;

  // Evita reprocessar o mesmo objeto/array
  if (visited.has(input)) return false;
  visited.add(input);

  // Se for array, checa cada item
  if (Array.isArray(input)) {
    for (const item of input) {
      if (hasBlockedKeyDeep(item, visited)) return true;
    }
    return false;
  }

  // É um objeto: verifica as chaves do nível atual
  for (const key of Object.keys(input)) {
    if (BLOCK_KEYS.has(key)) return true;
  }

  // Depois, varre recursivamente os valores
  for (const value of Object.values(input)) {
    if (hasBlockedKeyDeep(value, visited)) return true;
  }

  return false;
}

const ScoreRating = ({ score, data, block = true }) => {
  const hasBlocked = hasBlockedKeyDeep(data) && block;

  // Se tiver chave bloqueada em QUALQUER nível, não renderiza
  if (hasBlocked) return null;

  return (
    <>
      {score?.statusRetorno == 1 && (
        <div>
          <TitleStripe>⭐ Score de crédito</TitleStripe>
          <div className="rounded-2xl border border-gray-200 mt-5">
            <div className="w-full px-4 py-2 flex flex-row items-center justify-between gap-6 max-w-6xl mx-auto">
              {/* Coluna 1 - Nota + Descrição */}
              <div className="flex items-center gap-4 flex-1 min-w-0">
                {/* Imagem do score */}
                <img
                  src={`/assets/score/rating/${getLetterScore(
                    +score?.score
                  )}.png`}
                  alt="Nota Score"
                  className="w-32 shrink-0"
                />

                {/* Texto */}
                <div className="text-sm text-gray-700 leading-snug">
                  <div className="font-semibold mb-1">Descritivo:</div>
                  <div className="text-gray-600 text-xs md:text-sm border border-gray-300 bg-gray-50 p-2 rounded-md">
                    {getScoreLegends(getLetterScore(+score?.score))}
                  </div>
                </div>
              </div>

              {/* Coluna 2 - Régua com marcador */}
              <div className="relative w-[480px]">
                <div
                  className="absolute bottom-10 z-10"
                  style={{
                    left: `${
                      +score?.score <= 50
                        ? 2
                        : +score?.score > 900
                        ? 83
                        : +score?.score / 10 - 9
                    }%`,
                  }}
                >
                  <div className="bg-white border border-gray-300 px-3 py-1 rounded-full text-sm font-semibold shadow text-center min-w-[50px]">
                    {+score?.score}
                  </div>
                </div>

                <img
                  src="/assets/score/regua/regua_2.png"
                  alt="Régua Score"
                  className="w-full rounded"
                />
              </div>
            </div>
          </div>
          <div className="mt-2 px-4 pb-4 text-xs text-gray-500 italic">
            Esta análise de rating foi calculada pela nossa inteligência
            artificial, considerando múltiplos fatores como restrições,
            informações cadastrais, ocorrências financeiras e outros indicadores
            relevantes.
          </div>
        </div>
      )}
    </>
  );
};

export default ScoreRating;
